export const PAGE_SIZE = 20;

export const ORDER_STATUS_VALUES = ["New", "Printed", "Completed", "Shipped"];
export const ORDER_PAYMENT_VALUES = ["Pending", "Paid", "Unpaid", "Cancelled"];
